import SettingDetail from './SettingDetail';
import styles from './styles/modal.module.css';

export default function SettingModal({ yAxisList, filteredYAxisList, settings, updateSetting, closeModal }) {
    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>그래프 세부 설정</p>
            <div className={styles.containerContent}>
                <div className={styles.boxSubTitle}>
                    <p>변수명</p>
                    <p>막대/선</p>
                    <p>기준 Y축</p>
                </div>
                <div className={styles.boxSetting}>
                    {settings.map((setting, index) => (
                        <div className={styles.setting} key={index}>
                            <div className={styles.number}>Y-{index + 1}</div>
                            <SettingDetail yAxisList={yAxisList}
                                           filteredYAxisList={filteredYAxisList}
                                           index={index}
                                           setting={setting}
                                           updateSetting={updateSetting}
                            />
                        </div>
                    ))}
                </div>
            </div>
            <button className={styles.btnClose} onClick={closeModal}>닫기</button>
        </div>
    );
}
